// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { TotalDomainsService } from '@client/app/services/total-domains/total-domains.service';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { DomainsService } from '@client/app/services/domains/domains.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { CoreDomainService } from '@client/app/core/services/domain/core-domain.service';
import { safeClone } from '@client/app/shared/utils/object-utils';

@Component({
    selector: 'global-policy-dialogs-targets',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header [header]="'Policy hits per domain' | translate"
                         panelLeftClass="col-40 pt-1">
                <page-header-content>
                    <div class="d-flex justify-content-end mon-dialog-delay-fadein">
                        <div class="p-1">
                            <csv-export-button clsSize="py-2 px-3" clsMargin="mr-0" [exports]="exports"></csv-export-button>
                        </div>
                    </div>
                </page-header-content>
            </page-header>
        </div>
        <div class="mon-dialog-body">
            <div class="card panel-monsido-card outer-t outer-r outer-l">
                <div class="card-body">
                    <mon-spinner [loading]="loading">
                        <table class="table table-hover table-fixed">
                            <thead>
                            <tr>
                                <th class="col-sm-20 col-md-28" translate>Domain</th>
                                <th class="col-sm-12 col-md-10 text-center" colspan="3" translate>Hits on domain</th>
                                <th class="col-sm-16 col-md-10 text-center"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let targetDomain of targetDomainList; let i = index; trackBy: trackByIndex">
                                <td class="text-ellipsis">
                                    <url-title *ngIf="targetDomain.url" (click)="goToDomain(targetDomain.id, targetDomain.type, targetDomain.domainId)" [url]="targetDomain.url" [title]="targetDomain.title" [active]="false"></url-title>
                                </td>
                                <td></td>
                                @let matchesPercentage = { value: 0 };
                                <td class="text-v-middle text-center" mon-set-background-color (percentage)="matchesPercentage.value = $event" color="#4384F3" [count]="targetDomain.matches_count" [maxCount]="maxCount">
                                    <span [ngClass]="{'text-white': matchesPercentage.value > 0.4}">{{targetDomain.matches_count | monNumber}}</span>
                                </td>
                                <td></td>
                                <td class="text-v-middle text-right" [attr.aria-label]="getAriaLabel(targetDomain.title)">
                                    <button (click)="goToDomain(targetDomain.id, targetDomain.type, targetDomain.domainId)" type="button" class="btn btn-border-radius btn-secondary" translate>
                                        Open domain policy
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </mon-spinner>
                </div>
            </div>
        </div>
    `,
})
export class GlobalPolicyDialogsTargetsComponent implements OnInit {
    @Input() policy: any;
    @Input() monDialogId?: string;

    loading = false;
    targetDomainList: any[] = [];
    domains: any[] = [];
    cPolicy: any;
    maxCount = 0;
    percentages: any[] = [];
    exports: any[] = [];

    constructor (
        private stateService: StateService,
        private coreDomainService: CoreDomainService,
        private monDialog: MonDialog,
        private totalDomainsService: TotalDomainsService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
        private domainsService: DomainsService,
        private translateService: TranslateService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    trackByIndex (index: number): number {
        return index;
    }

    getAriaLabel (title: string): string {
        return this.translateService.getString('Go to the policy dashboard of the domain [[title]]', { title });
    }

    private activate (): void {
        this.loading = true;
        this.cPolicy = safeClone(this.policy);
        this.maxCount = this.cPolicy.targets.reduce((num: number, domain: any) => {
            return Math.max(num, domain.matches_count);
        }, 0);
        this.cPolicy.targets = this.cPolicy.targets.sort((a: any, b: any) => {
            return a.matches_count > b.matches_count ? -1 : a.matches_count < b.matches_count ? 1 : 0;
        });
        this.getDomains();
        this.exports = [
            {
                data: {
                    category: 'urls_with_policy_across_domains',
                    category_ref: this.policy.id,
                    isGlobalExport: true,
                },
            },
        ];
    }

    private getDomains (): void {
        this.totalDomainsService.domainsEssential.subscribe((domains: any) => {
            this.domains = this.domainsService.flattenDomains(domains);
            this.targetDomainList = this.getDomainsFromTarget(this.cPolicy.targets);
            this.loading = false;
        });
    }

    goToDomain (id: any, type: any, groupId: any): void {
        const params: any = {
            domainId: id,
            policy_id: this.policy.id,
            search: this.policy.name,
        };
        if (type === 'DomainGroup') {
            params.domainId = groupId;
            params.domain_group = id;
        }
        this.monDialog.close(this.monDialogId, null);

        this.monUIRouterTransitionService.onTransitionFinished(
            () => this.stateService.go('base.customer.domain.policy.policies', params).then(() => {
                this.coreDomainService.changeDomain();
            }, () => {}),
        );
    }

    private getDomainsFromTarget (domainTargets: any[]): any[] {
        return domainTargets.map((target: any) => {
            const currentDomain = this.domains.find((domain: any) => domain.type === target.type && domain.id === target.id);
            if (!currentDomain) {
                target.url = this.translateService.getString('Loading...');
                return target;
            }
            if (currentDomain.type === 'DomainGroup') {
                const parentDomain = this.domains.find((domain: any) => domain.id === currentDomain.domainId);
                target.url = parentDomain.url;
                target.domainId = currentDomain.domainId;
            } else {
                target.url = currentDomain.url;
            }
            return target;
        });
    }
}
